module.exports = __webpack_public_path__ + "static/media/91.e86a8091.jpg";